import { Banner } from '@sunwebgroup/uds-ui/banner'
import { Button } from '@sunwebgroup/uds-ui/button'
import * as React from 'react'
import { useIntl } from '@/intl'
import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore'
import { useGroupResponsibleUseCases } from '../dependencies'
import { isRoomAssignmentProcessing } from '../selectors'
import styles from './RoomAssignmentStatusBanner.module.css'

export function RoomAssignmentStatusBanner() {
  const isBlocked = useGroupResponsibleStore(state => state.bookingData.group.isBlocked)
  const roomAssignmentStatus = useGroupResponsibleStore(state => state.roomAssignmentStatus)
  const isProcessing = useGroupResponsibleStore(isRoomAssignmentProcessing)
  const useCases = useGroupResponsibleUseCases()
  const intl = useIntl()

  const isRefreshing = roomAssignmentStatus === 'refreshing'
  const isSuccess = roomAssignmentStatus === 'success'
  const hasError = roomAssignmentStatus === 'error'
  const actionsPosition = isSuccess ? 'right' : 'bottom'

  if (!isBlocked && !isSuccess) {
    return null
  }

  function handleRefresh() {
    void useCases.roomAssignmentStatusRefreshed()
  }

  function handleSuccessBannerDismissed() {
    useCases.roomAssignmentSuccessBannerDismissed()
  }

  return (
    <Banner
      color={hasError ? 'danger' : isBlocked ? 'informative' : 'success'}
      size="M"
      hasIcon
      contentIsCentered={isSuccess}
      className={styles.processingBanner}
    >
      <Banner.ContentWrapper
        actionsPosition={actionsPosition}
        className={isSuccess ? styles.processingContent : undefined}
      >
        <Banner.TextsWrapper>
          {isProcessing
            ? (
                <>
                  <Banner.Text>
                    {intl.formatMessage({ id: 'groups_responsible_room_assignment_processing' })}
                  </Banner.Text>
                  <Banner.SupportingText>
                    {intl.formatMessage({ id: 'groups_responsible_room_assignment_processing_supporting' })}
                  </Banner.SupportingText>
                </>
              )
            : (
                <Banner.Text>
                  {intl.formatMessage({
                    id: hasError
                      ? 'groups_responsible_room_assignment_error'
                      : 'groups_responsible_room_assignment_saved',
                  })}
                </Banner.Text>
              )}
        </Banner.TextsWrapper>
        <Banner.ActionsWrapper actionsPosition={actionsPosition}>
          {isBlocked
            ? (
                <Button
                  size="S"
                  variant="secondary"
                  onClick={handleRefresh}
                  isLoading={isRefreshing}
                  disabled={isRefreshing}
                >
                  {intl.formatMessage({ id: 'groups_responsible_room_assignment_refresh' })}
                </Button>
              )
            : (
                <Button
                  size="S"
                  variant="secondary"
                  onClick={handleSuccessBannerDismissed}
                >
                  {intl.formatMessage({ id: 'groups_responsible_room_assignment_dismiss' })}
                </Button>
              )}
        </Banner.ActionsWrapper>
      </Banner.ContentWrapper>
    </Banner>
  )
}
